import { useEffect, useState } from "react";

type Viewport = {
  isMobile: boolean;
  isNarrow: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isWide: boolean;
};

// Прагове: мобилно < 480px (телефони), таблет 480–1023px, десктоп 1024–1439px, широк ≥ 1440px
// isNarrow (< 640) — семантично „тесен layout"; покрива телефоните + малки таблети в portrait,
// където колоните/chrome-а трябва да се свият, но екранът не е непременно телефон.
const readViewport = (): Viewport => {
  if (typeof window === "undefined") {
    return {
      isMobile: false,
      isNarrow: false,
      isTablet: false,
      isDesktop: true,
      isWide: false,
    };
  }
  const width = window.innerWidth;
  return {
    isMobile: width < 480,
    isNarrow: width < 640,
    isTablet: width >= 480 && width < 1024,
    isDesktop: width >= 1024,
    isWide: width >= 1440,
  };
};

const sameViewport = (previous: Viewport, next: Viewport) =>
  previous.isMobile === next.isMobile &&
  previous.isNarrow === next.isNarrow &&
  previous.isTablet === next.isTablet &&
  previous.isDesktop === next.isDesktop &&
  previous.isWide === next.isWide;

export const useViewport = () => {
  const [viewport, setViewport] = useState(readViewport);

  useEffect(() => {
    // Нов обект САМО при сменен праг. На телефон „resize" идва и при
    // показване/скриване на клавиатурата (само височината, по няколко пъти
    // по време на анимацията) — нов обект всеки път прерисуваше целия екран
    // (в „Маркиране" — целия каталог). Android чака кадъра с новия размер и
    // на Xiaomi целият екран почерняваше за миг при скриване на клавиатурата.
    const onResize = () =>
      setViewport((previous) => {
        const next = readViewport();
        return sameViewport(previous, next) ? previous : next;
      });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return viewport;
};
